import { Image } from './image.model';

/**
 * The structure of the Hero object
 */
export class Hero {
  description = '';
  tegel: Image = new Image();
}
